import type { CourseAPIResponse } from 'app/types/courses';

/**
 * Resolves the program cover/image URL for a practice course.
 *
 * The custom practice flow only knows the course `id`, which matches the cached
 * course `guid` (same identifier the ToC and session-generation endpoints use).
 * This pure helper looks the course up in the persisted courses cache and returns
 * its image. The icon is rendered in a small square slot, so `picture` (a more
 * square/icon-like image) is preferred over `program_cover` (a wide banner that
 * would crop awkwardly), falling back to `theme_image`. Returns `undefined` when
 * the course is not cached or has no image, so callers can fall back to a generic icon.
 *
 * No HTTP request is performed: the cache is the only source.
 */
function resolveProgramIconUrl(courseId: string, courses: CourseAPIResponse[] | null | undefined): string | undefined {
  if (!courseId || !courses?.length) {
    return undefined;
  }

  const course = courses.find((item) => item?.guid === courseId);

  return course?.picture || course?.program_cover || course?.theme_image || undefined;
}

export default resolveProgramIconUrl;
